import { Component } from "react";
import { createRoot } from "react-dom/client";
import { createStore, applyMiddleware, compose, Store } from "redux";
import { Provider } from "react-redux";
import thunkMiddleware from "redux-thunk";
import { rootReducer } from "./Reducers/root";
import { IStore, IInitialSettings, Step } from "./DataTypes/storeTypes";
import { MainPanel } from "./React/MainPanel";
import { loadState, resetState, saveState } from "./storeManager";
import * as Actions from "./Actions/actions";
import { EventNames, listenEvent } from "../portalEvents";
import { GlobalThemeProvider } from "@powerdiary/components-library/lib";
import * as LocalStorage from "../Common/localStorageSessionManager";

export class AppointmentBookingProvider extends Component<IInitialSettings> {
    store: Store<IStore>;

    constructor(props: IInitialSettings) {
        super(props);

        LocalStorage.getLocalStorageSessionManager(
            props.accountInitialSettings.organisationInfo.sgId
        ).setTimestampOnLoad();

        let state = loadState(props);

        const atConfirmation = state.common.currentStep == Step.Confirmation;
        const hasBeenBooked = state.common.bookedAppointment && state.common.bookedAppointment.id;
        //if there's already a booked appt, let's clear the state and start fresh
        if (atConfirmation && hasBeenBooked) {
            state = resetState(props);
        }

        const data = state;

        //in order to use redux devtools extension
        const composeEnhancers = window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"] || compose;
        this.store = createStore(rootReducer, data, composeEnhancers(applyMiddleware(thunkMiddleware)));

        this.store.dispatch<any>(Actions.setStep(data.common.currentStep));

        this.store.subscribe(() => {
            saveState(this.store.getState(), props);
        });
    }

    componentDidMount() {
        listenEvent(EventNames.GoHome, () => {
            this.store.dispatch(Actions.requestCancel(true));
        });
    }

    render() {
        return (
            <GlobalThemeProvider>
                <Provider store={this.store}>
                    <MainPanel />
                </Provider>
            </GlobalThemeProvider>
        );
    }
}

export const renderApptBookingView = (params: IInitialSettings, mountPoint: string) => {
    const container = document.getElementById(mountPoint);
    const root = createRoot(container);
    root.render(
        <GlobalThemeProvider>
            <AppointmentBookingProvider {...params} />
        </GlobalThemeProvider>
    );
};
